import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { TopbarItemEventDTO } from '../model/dto/TopbarItemEvent.dto';
import { TopbarItem } from '../model/topbar-item.model';

export class TopbarFilterSource {
  filtros: TopbarItem[];
}

@Injectable()
export class TopbarFilterHandlerService {

  // FIXME: REFATORAR => resolver sem 
  // utilizar Subject e Source estáticos
  private static addFilterInTopbarSubjectSingleton: Subject<TopbarFilterSource> = null;
  private static addFilterInTopbarSourceSingleton$: Observable<TopbarFilterSource> = null;

  // private static topbarSingleFilterSubject: Subject<TopbarItemEventDTO> = null;
  private static topbarAllFiltersSubject: Subject<TopbarItemEventDTO[]> = null;

  constructor() {
  }
  
  refresh(): void {
  }

  onHide(): void {
    // emite um objeto vazio para todos os listeners dos filtros,
    // para que os controllers possam atualizar seus dados com os filtros vazios.
    this.clearFiltersSources();
  }

  onShow(): void {
  }

  build(filters: TopbarFilterSource): void {
    TopbarFilterHandlerService.addFilterInTopbarSubjectSingleton.next(filters);
  }

  private clearFiltersSources(): void {
    if ( this.getTopbarAllFiltersSubject() ) {
      this.getTopbarAllFiltersSubject().next();
    }
  }

  public getAddFilterInTopbarSourceSingleton(): Observable<TopbarFilterSource> { // TopbarFilterSource
    if ( !TopbarFilterHandlerService.addFilterInTopbarSourceSingleton$ ) {
      TopbarFilterHandlerService.addFilterInTopbarSourceSingleton$ = this.getAddFilterInTopbarSubjectSingleton().asObservable();
    }

    return TopbarFilterHandlerService.addFilterInTopbarSourceSingleton$;
  }

  public getAddFilterInTopbarSubjectSingleton(): Subject<TopbarFilterSource> { // TopbarFilterSource
    if ( !TopbarFilterHandlerService.addFilterInTopbarSubjectSingleton ) {
      TopbarFilterHandlerService.addFilterInTopbarSubjectSingleton = new Subject<TopbarFilterSource>();
    }

    return TopbarFilterHandlerService.addFilterInTopbarSubjectSingleton;
  }

  // public getTopbarSingleFilterSubject(): Subject<TopbarItemEventDTO> {
  //   return TopbarFilterHandlerService.topbarSingleFilterSubject;
  // }

  public getTopbarAllFiltersSubject(): Subject<TopbarItemEventDTO[]> {
    return TopbarFilterHandlerService.topbarAllFiltersSubject;
  }

  // public setTopbarSingleFilterSubject(subject: Subject<TopbarItemEventDTO>): void {
  //   TopbarFilterHandlerService.topbarSingleFilterSubject = subject;
  // }

  public setTopbarAllFiltersSubject(subject: Subject<TopbarItemEventDTO[]>): void {
    TopbarFilterHandlerService.topbarAllFiltersSubject = subject;
  }  

}
